import { Component, ReactNode, ErrorInfo } from "react";
import { ErrorFallback } from "./fallback-ui";

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface AppErrorBoundaryProps {
  children: ReactNode;
  onNavigateHome?: () => void;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: AppErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('App Error Boundary caught an error:', error, errorInfo);
    // Here you could send error to logging service
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: undefined });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={this.state.error}
          onRetry={this.handleRetry}
          onNavigateHome={this.props.onNavigateHome}
          title="Application Error"
          message="The application encountered an unexpected error. Please try refreshing the page."
        />
      );
    }

    return this.props.children;
  }
}